/* MUST HAVE NO DEPENDENCIES */


/*
  switch videos for mobile and desktop
  responsive video script 
*/
function initResponsiveVideos() {
  let videos = document.querySelectorAll('.js-responsive-video');

  const windowSize = innerWidth;
  const mobileBreakpoint = 768

  let isMobile = windowSize > mobileBreakpoint ? false : true;

  videos.forEach(video => {
    let mobileSrc = video.dataset.mobileSrc;
    let src = video.dataset.src;

    let source = document.createElement('source');

    
    source.setAttribute('type', 'video/mp4');

    if (isMobile) {
      source.setAttribute('src', mobileSrc);
      if (video.dataset.mobilePoster) {
        video.setAttribute('poster', video.dataset.mobilePoster)
      }

      if(video.dataset.mobileHeight){
        video.setAttribute('height', video.dataset.mobileHeight);
      }

      if(video.dataset.mobileWidth){
        video.setAttribute('width', video.dataset.mobileWidth);
      }
      
    } else {
      source.setAttribute('src', src);
      if (video.dataset.desktopPoster) {
        video.setAttribute('poster', video.dataset.desktopPoster)
      }
    }

    video.appendChild(source);

    video.load();
  });
}


/* 
  RUN THIS CODE BEFORE PARALLAX ON RECENTLY VIEWED PRODUCTS 
  CHANGE THE OFFSET OF MOBILE TO MAKE IT RUN SMOOTHER
*/
function fixMobileOffsetForJarallaxElement(){
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const mobileOffset = '90 0';
  document.querySelectorAll('.js-recently-viewed-split-container[data-jarallax-element]').forEach((item) =>{
    if(isMobile){
      item.setAttribute('data-jarallax-element', mobileOffset);
    }
  })
}

document.addEventListener("responsive-video", initResponsiveVideos);

fixMobileOffsetForJarallaxElement()
initResponsiveVideos();